import './App.css'

//import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
//import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';
import apis from './apis';
//import { Root } from './components/Root';
import { OverflowTooltip, SignInPage, TableColumn } from '@backstage/core-components';

/*import {
  AlertDisplay,
  OAuthRequestDialog,
} from '@backstage/core-components';
*/
import { createApp } from '@backstage/frontend-defaults';
import LightIcon from '@mui/icons-material/WbSunny';
import DarkIcon from '@mui/icons-material/WbSunny';
import { customDarkTheme, customLightTheme } from './theme/customTheme';
import { UnifiedThemeProvider } from '@backstage/theme';

//import { HomepageCompositionRoot, VisitListener } from '@backstage/plugin-home';
//import { VisitListener } from '@backstage/plugin-home';

//import { HomePage } from './components/home/HomePage';
//import { CustomRepoUrlPickerFieldExtension } from './scaffolder/customRepoUrlPicker/CustomRepoUrlPicker';
import { configApiRef, gitlabAuthApiRef, useApi } from '@backstage/core-plugin-api';
import { costInsightsAwsPlugin } from '@aws/cost-insights-plugin-for-backstage';
import amazonEcrPlugin from '@internal/amazon-ecr-plugin-for-backstage/alpha';
import amazonEcsPlugin from '@internal/amazon-ecs-plugin-for-backstage/alpha';
import amazonSecurityHubPlugin from '@internal/aws-securityhub-plugin-for-backstage/alpha';
import genaiPlugin from '@internal/genai-plugin-for-backstage/alpha';

import { userSettingsTranslations } from './translations/user-settings/user-settings';
import { catalogImportTranslations } from './translations/catalog/catalog-import';
import { gitlabTranslations } from './translations/gitlab/gitlab';
import { catalogReactTranslations } from './translations/catalog/catalog-react';
import { scaffolderTranslations } from './translations/scaffolder/scaffolder';
import { scaffolderReactTranslations } from './translations/scaffolder/scaffolder-react';
import { appTranslations } from './translations/app/app';
import { kubernetesReactTranslations, kubernetesTranslations } from './translations/kubernetes/kubernetes';
import './styles.css';

import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
//import techRadarPlugin from '@backstage-community/plugin-tech-radar/alpha';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import rbacPlugin from '@backstage-community/plugin-rbac/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import techRadarPlugin from '@backstage-community/plugin-tech-radar/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import gitlabPlugin from '@immobiliarelabs/backstage-plugin-gitlab/alpha';
import homePlugin from '@backstage/plugin-home/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import costInsightsPlugin from '@internal/backstage-community-plugin-cost-insights/alpha';
import { Category, Api } from '@mui/icons-material';

//import searchPlugin  from '@backstage/plugin-search/alpha';
//import pluginCatalogGraph  from '@backstage/plugin-catalog-graph/alpha';

import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint, ThemeBlueprint } from '@backstage/plugin-app-react';
import { navModule } from './modules/nav';
import { CatalogIndexPage, CatalogTable, CatalogTableColumnsFunc, CatalogTableRow } from '@backstage/plugin-catalog';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { techRadarCustomClient } from './lib/tech-radar-custom-client';
import { convertLegacyPlugin } from '@backstage/core-compat-api';

const customLightThemeExtension = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Light',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={customLightTheme} children={children} />
      ),
    },
  },
});


const customDarkThemeExtension = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Dark',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={customDarkTheme} children={children} />
      ),
    },
  },
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      if (configApi.getString('auth.environment') === 'development') {
        return (
          <SignInPage
            {...props}
            providers={['guest']}
          />
        );
      }
      return (
        <SignInPage
          {...props}
          provider={{
            id: 'gitlab-auth-provider',
            title: 'GitLab',
            message: 'Sign in using GitLab',
            apiRef: gitlabAuthApiRef,
          }}
        />
      );
    },
  },
});

const createUserEmailColumn = (): TableColumn<CatalogTableRow> => ({
  title: 'E-mail do usuário',
  field: 'entity.spec.profile.email',
  render: ({ entity }) => {
    const profile = entity.spec?.profile as { email?: string } | undefined;
    return (
      <OverflowTooltip
        text={profile?.email || 'N/A'}
        placement="bottom-start"
      />
    );
  },
});

const createUsernameColumn = (): TableColumn<CatalogTableRow> => ({
  title: 'Username',
  field: 'entity.metadata.name',
  render: ({ entity }) => {
    return (
      <OverflowTooltip
        text={entity.metadata.name || 'N/A'}
        placement="bottom-start"
      />
    );
  },
});


const customColumnsFunction: CatalogTableColumnsFunc = entityListContext => {
  const kindValue = entityListContext.filters.kind?.value;

  // Define column configurations for each entity kind
  const columnsByKind: Record<string, TableColumn<CatalogTableRow>[]> = {
    user: [
      CatalogTable.columns.createNameColumn(),
      createUserEmailColumn(),
      createUsernameColumn()
    ],
    group: [
      CatalogTable.columns.createNameColumn(),
      CatalogTable.columns.createSpecTypeColumn(),
    ],
    location: [
      CatalogTable.columns.createNameColumn(),
      CatalogTable.columns.createSpecTypeColumn(),
    ],
    template: [
      CatalogTable.columns.createNameColumn(),
      CatalogTable.columns.createOwnerColumn(),
      CatalogTable.columns.createSpecTypeColumn(),
    ],
    system: [
      CatalogTable.columns.createNameColumn(),
      CatalogTable.columns.createOwnerColumn(),
      CatalogTable.columns.createMetadataDescriptionColumn(),
    ],
    component: [
      CatalogTable.columns.createSystemColumn(),
      CatalogTable.columns.createNameColumn(),
      CatalogTable.columns.createOwnerColumn(),
      CatalogTable.columns.createSpecTypeColumn(),
    ],
  };

  return columnsByKind[kindValue as string] || CatalogTable.defaultColumnsFunc(entityListContext);
};

const techRadarPluginOverride = techRadarPlugin.withOverrides({
  extensions: [
    techRadarPlugin.getExtension('api:tech-radar').override({
      params: defineParams =>
        defineParams({
          api: techRadarApiRef,
          deps: {},
          factory: () => new techRadarCustomClient(),
        }),
    })
  ]
})

const apiDocsPluginOverride = apiDocsPlugin.withOverrides({
  extensions: [
    apiDocsPlugin.getExtension('page:api-docs').override({
      params: {
        icon: <Api fontSize="inherit" />,
        noHeader: true
      },
    }),
  ],
});

const convertedCostInsightsAwsPlugin = convertLegacyPlugin(costInsightsAwsPlugin, {
  extensions: [],
});

const costInsightsPluginOverride = costInsightsPlugin.withOverrides({
  extensions: [
    costInsightsPlugin.getExtension('api:cost-insights').override({
      disabled: true
    })
  ]
})

const catalogPluginOverride = catalogPlugin.withOverrides({
  extensions: [
    catalogPlugin.getExtension('page:catalog').override({
      params: {
        icon: <Category />,
        noHeader: true,
        loader: async () => (
          <CatalogIndexPage
            pagination={{ mode: 'offset', limit: 20 }}
            initiallySelectedFilter="all" columns={customColumnsFunction}
          />
        ),
      },
    }),
  ],
});

import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';
import { CustomHomepageGrid } from '@backstage/plugin-home';
import { Content, Header, Page } from '@backstage/core-components';
import { Fragment } from 'react';
import { customHomePlugin } from './plugins/home';
import { entityDependencyContentExtension } from './components/catalog/entity-page/content/dependencies';

export const myHomePageLayout: any = HomePageLayoutBlueprint.make({
  params: {
    loader: async () =>
      function MyHomePageLayout({ widgets }) {
        return (
          <Page themeId="home">
            <Header title="Welcome" />
            <Content>
              <CustomHomepageGrid>
                {widgets.map((widget, index) => (
                  <Fragment key={widget.name ?? index}>
                    {widget.component}
                  </Fragment>
                ))}
              </CustomHomepageGrid>
            </Content>
          </Page>
        );
      },
  },
});
const app = createApp({
  features: [
    catalogPluginOverride,
    techRadarPluginOverride,
    scaffolderTranslations,
    scaffolderReactTranslations,
    appTranslations,
    userSettingsTranslations,
    gitlabTranslations,
    catalogImportTranslations,
    catalogReactTranslations,
    catalogImportTranslations,
    kubernetesTranslations,
    kubernetesReactTranslations,
    rbacPlugin,
    amazonEcsPlugin,
    amazonEcrPlugin,
    amazonSecurityHubPlugin,
    genaiPlugin,
    techdocsPlugin,
    catalogImportPlugin,
    scaffolderPlugin,
    apiDocsPluginOverride,
    orgPlugin,
    userSettingsPlugin,
    catalogGraphPlugin,
    searchPlugin,
    gitlabPlugin,
    navModule,
    homePlugin,
    customHomePlugin,
    kubernetesPlugin,
    convertedCostInsightsAwsPlugin,
    costInsightsPluginOverride,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage, customLightThemeExtension, customDarkThemeExtension, entityDependencyContentExtension, ...apis],
    }),
    createFrontendModule({
      pluginId: 'home',
      extensions: [myHomePageLayout],
    })
  ]
});

export default app.createRoot();